import { Observable } from "rxjs";
import { addNotification } from "../toaster/actions";
import { actionTypes } from "./actionTypes";
import { createErrorNotification, createSuccessNotification, } from "../toaster/creators";
const mapAction2Notification = (action) => {
    switch (action.type) {
        case actionTypes.IMPORT_ERROR:
            const errorNotification = createErrorNotification(`Error uploading dataset for ${action.payload.program}: ${action.payload.error}`, { showIcon: false });
            return addNotification(errorNotification);
        case actionTypes.IMPORT_FINISH:
            const successNotification = createSuccessNotification(`Dataset uploaded for ${action.payload.program}`, { showIcon: false });
            return addNotification(successNotification);
        default:
            return undefined;
    }
};
export function createNotificationsEpicForAction() {
    return (actions$) => actions$
        .ofType(actionTypes.IMPORT_ERROR, actionTypes.IMPORT_FINISH)
        .mergeMap((action) => Observable.of(mapAction2Notification(action)));
}
//# sourceMappingURL=notification.js.map